import CloseIconButton from "components/AppModalDialogsV2/Dialogs/lib/CloseIconButton";
import useCalculateScale from "components/PopUpManager/hooks/useCalculateScale";
import { useAppDispatch, useImagePath } from "hooks";
import { clubGiftsGaloreAssets } from "assets/cdn";
import { onClosePopUp } from "redux/slices";
import { Body, Container, Header, Title } from "./styles";

interface CGGNotEnoughClubMembersProps {}

export const CGGNotEnoughClubMembers = ({}: CGGNotEnoughClubMembersProps) => {
	const dispatch = useAppDispatch();
	const scale = useCalculateScale(363, 338);
	const { getImage } = useImagePath("cdn");
	const headImageUrl = getImage(
		clubGiftsGaloreAssets.v2.popups.shared.background
	);
	const titleUrl = getImage(clubGiftsGaloreAssets.v2.popups.shared.title);

	const onClose = () => {
		dispatch(onClosePopUp());
	};

	return (
		<Container scale={scale}>
			<Header data-image={headImageUrl}>
				<img src={titleUrl} alt="Club gifts galore" />
			</Header>
			<CloseIconButton onClose={onClose} />
			<Body>
				<Title>
					Not enough Club Members
					<br /> available to contribute! Invite
					<br /> more members to your Club.
				</Title>
			</Body>
		</Container>
	);
};
